import React from "react";
import { TableCell, TableSortLabel } from "@mui/material";
import TableHeader from "@crema/core/AppTable/TableHeader";

interface TableHeadingProps {
  order: "asc" | "desc";
  orderBy: string;
  onSort: (property: string) => void;
}

const COLUMN_WIDTHS: Record<string, number> = {
  action: 130,
  selection: 130,
  planName: 150,
  status: 130,
  planGroupCode: 150,
  rentExclTax: 130,
  planDuration: 150,
  popPlan: 130,
};

const headCells = [
  { id: "selection", label: "Selection" },
  { id: "planName", label: "Plan Name" },
  { id: "status", label: "Status" },
  { id: "planGroupCode", label: "Plan Group Code" },
  { id: "rentExclTax", label: "Base Price" },
  { id: "planDuration", label: "Plan Duration" },
  { id: "popPlan", label: "Popular Plan" },
  { id: "planClassification ", label: "Plan Classification" },
  { id: "deviceSecurity ", label: "Device Security" },
];

const TableHeading: React.FC<TableHeadingProps> = ({ order, orderBy, onSort }) => {
  return (
    <TableHeader>
      <TableCell
        align="left"
        sx={{ fontSize: 14, width: COLUMN_WIDTHS["action"], minWidth: 120, maxWidth: 140 }}
      >
        Action
      </TableCell>

      {headCells.map((headCell) => (
        <TableCell
          key={headCell.id}
          align="left"
          sortDirection={orderBy === headCell.id ? order : false}
          sx={{
            fontSize: 14,
            width: COLUMN_WIDTHS[headCell.id],
            minWidth: 120,
            maxWidth: 160,
          }}
        >
          <TableSortLabel
            active={orderBy === headCell.id}
            direction={orderBy === headCell.id ? order : "asc"}
            onClick={() => onSort(headCell.id)}
          >
            {headCell.label}
          </TableSortLabel>
        </TableCell>
      ))}
    </TableHeader>
  );
};

export default TableHeading;
